import { supabase } from '../lib/supabase';

export const checkEnumValues = async () => {
  console.log('=== Checking Database Enum Values ===');
  
  // Method 1: Query pg_enum to get actual enum values
  const { data: enumData, error: enumError } = await supabase
    .rpc('get_enum_values', { enum_name: 'billing_status_enum' })
    .single();
    
  if (!enumError && enumData) {
    console.log('Enum values from database:', enumData);
  }
  
  // Method 2: Try a raw SQL query if RPC doesn't work
  const { data: sqlData, error: sqlError } = await supabase
    .from('projects')
    .select('billing_status')
    .not('billing_status', 'is', null)
    .limit(50);
    
  if (!sqlError && sqlData) {
    const uniqueValues = [...new Set(sqlData.map(p => p.billing_status))];
    console.log('Actual billing_status values in use:', uniqueValues);
  }
  
  // Method 3: Test common enum formats
  console.log('\n=== Testing Common Enum Formats ===');
  
  // Get a test project
  const { data: testProject } = await supabase
    .from('projects')
    .select('id, billing_status')
    .limit(1)
    .single();
    
  if (!testProject) {
    console.error('No test project found');
    return;
  }
  
  console.log('Test project:', testProject);
  const originalStatus = testProject.billing_status;
  
  // Test different formats
  const testFormats = [
    { display: 'Ready to Invoice', variants: [
      'Ready to Invoice',
      'Ready_to_Invoice', 
      'ready_to_invoice',
      'READY_TO_INVOICE',
      'ready-to-invoice',
      'readytoinvoice',
      'Ready To Invoice'
    ]},
    { display: 'Quoted', variants: [
      'Quoted',
      'quoted',
      'QUOTED'
    ]},
    { display: 'Invoiced', variants: [
      'Invoiced',
      'invoiced',
      'INVOICED'
    ]}
  ];
  
  for (const format of testFormats) {
    console.log(`\nTesting variants for "${format.display}":`);
    for (const variant of format.variants) {
      const { error } = await supabase
        .from('projects')
        .update({ billing_status: variant })
        .eq('id', testProject.id);
        
      if (!error) {
        console.log(`✅ SUCCESS: "${variant}" is valid!`);
        
        // Check how it's stored
        const { data: checkData } = await supabase
          .from('projects')
          .select('billing_status')
          .eq('id', testProject.id)
          .single();
          
        console.log(`   Stored in database as: "${checkData.billing_status}"`);
        break; // Found valid format for this status
      } else {
        console.log(`❌ Failed: "${variant}" - ${error.message.substring(0, 50)}...`);
      }
    }
  }
  
  // Restore original status if possible
  if (originalStatus) {
    await supabase
      .from('projects')
      .update({ billing_status: originalStatus })
      .eq('id', testProject.id);
  }
  
  return { success: true };
};

// Make available in console
if (typeof window !== 'undefined') {
  window.checkEnumValues = checkEnumValues;
  console.log('Enum checker available: window.checkEnumValues()');
}